import script from "./OAuthCompo.vue?vue&type=script&lang=js"
export * from "./OAuthCompo.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__